import { FC } from 'react'
import styles from './header-top.module.scss'
import ThemeSwitch from '@/components/features/ThemeSwitch'
import LangController from '@/components/features/LangController'
import BalanceButton from '@/components/ui/BalanceButton'
import SearchButton from '@/components/ui/SearchButton'
import LoginButton from '@/components/ui/LoginButton'
import RegisterButton from '@/components/ui/RegisterButton'
import Logotype from '@/components/ui/Logotype'
import Burger from './Burger'
import Link from 'next/link'
import useI18nPath from '@/hooks/i18n-path.hook'
import ModeSwitch from '@/components/features/ModeSwitch'

type HeaderTopProps = {
  onOpenBurgerMenu: () => void
}

const HeaderTop: FC<HeaderTopProps> = ({ onOpenBurgerMenu: handleOpenBurgerMenu }) => {
  const { getHrefLang } = useI18nPath()

  return (
    <div className={styles.header_top}>
      <div className="container">
        <div className={styles.inner}>
          <ModeSwitch className={styles.mode} />
          <ThemeSwitch className={styles.theme} />
          <LangController className={styles.language} />
          <BalanceButton className={styles.balance} />
          <SearchButton />
          <LoginButton className={styles.login} />
          <RegisterButton className={styles.registration} />
          <Link href={getHrefLang('/')} aria-label="Главная">
            <Logotype className={styles.logo} />
          </Link>
          <Burger onOpenBurgerMenu={handleOpenBurgerMenu} />
        </div>
      </div>
    </div>
  )
}

export default HeaderTop
